module.exports = __webpack_public_path__ + "media/Pika-1.fe618a57.mp4";